var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NewDesignModal,{attrs:{"title":_vm.titleName}},[_c('div',{staticClass:"player-container"},[(_setup.trailerClip)?_c(_setup.videoPlayer,{tag:"component",staticClass:"player",attrs:{"height":"100%","clip":_setup.trailerClip,"options":_setup.options,"isBackdrop":false,"isActive":true}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }